import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "../lib/seo";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Experience from "../components/Experience";
import ChildSeatsSection from "../components/ChildSeatsSection";
import Fleet from "../components/Fleet";
import Excellence from "../components/Excellence";
import ServicesDetail from "../components/ServicesDetail";
import Journal from "../components/Journal";
import B2B from "../components/B2B";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import { FinalCTA } from "../components/FinalCTA";

const Home = () => {
  const { hash } = useLocation();
  useSeo({
    title: "Airport Taxi Zürich | Fixpreis Chauffeurservice 24/7",
    description: "Zuverlässiger Flughafentransfer ab Zürich (ZRH) zum Fixpreis – 24/7, Flugverfolgung, kostenlose Wartezeit und professionelle Chauffeure. Transfers in die ganze Schweiz. Jetzt online buchen.",
    path: "/",
  });
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <Hero />
      <Services />
      <Experience />
      <ChildSeatsSection />
      <Fleet />
      <Excellence />
      <ServicesDetail />
      <Journal />
      <B2B />
      <Reviews />
      <FAQ />
      <Contact />
      <FinalCTA />
    </>
  );
};

export default Home;
